/* eslint-disable complexity */
/* eslint-disable max-lines */
import { FC, Fragment } from "react"
import { Translate } from "../../../../../../constant/Translate"
import { ItemCheckbox } from "../../../../../../_webui/layout/components/Form/Item/Checkbox"
import { ItemDatePickerRange } from "../../../../../../_webui/layout/components/Form/Item/DatePicker/Range"
import { ItemInput } from "../../../../../../_webui/layout/components/Form/Item/Input"
import { ItemSelect } from "../../../../../../_webui/layout/components/Form/Item/Select"
import { FormSearch } from "../../../../../../_webui/layout/components/Form/Search"
import { FormSearchLeft } from "../../../../../../_webui/layout/components/Form/Search/Left"
import { FormSearchRight } from "../../../../../../_webui/layout/components/Form/Search/Right"
import { SchedulesFormSearchProps } from "./models"
import { Styled } from "./styled"
import { SelectItems } from "../../../../../../constant/SelectItems"
import { Regex } from "../../../../../../constant/Regex"

const { REGEX_IS_DESKTOP } = Regex
const { OTHER_CITY_SELECT_ITEMS } = SelectItems
const { StyledFormSearchRightGroup, StyledGroupItem, StyledTitle } = Styled
const {
  TEXT_T009,
  TEXT_T191,
  TEXT_T193,
  TEXT_T194,
  TEXT_T195,
  TEXT_T196,
  TEXT_T197,
  TEXT_T217,
  TEXT_T219,
  TEXT_T220,
  TEXT_T619,
} = Translate

export const SchedulesFormSearch: FC<SchedulesFormSearchProps> = (props) => {
  const {
    arrivalCities,
    countries,
    departments,
    form,
    handleSearch,
    isDisabledArrivalCity,
    isHiddenBtnResetForm,
    isHiddenBtnSearchBasic,
    isPathnameSchedules,
    isSearchAdvance,
    onBlurBasic,
    onChangeArrivalCity,
    onChangeArrivalCountryCode,
    onClickReset,
    onKeyDownBasic,
    onOpenSearchAdvance,
  } = props

  return (
    <FormSearch
      form={form}
      heading={TEXT_T191}
      isAdvanced
      isHiddenReset={!isHiddenBtnResetForm}
      isHiddenSubmit={!isHiddenBtnSearchBasic}
      labelAlign="left"
      onClickAdvanced={onOpenSearchAdvance}
      onClickReset={onClickReset}
      onFinish={handleSearch}
      resetHtmlType="button"
    >
      <FormSearchLeft>
        {isPathnameSchedules ? (
          <ItemInput isReadOnly label={TEXT_T219} name="fullName" />
        ) : (
          <ItemInput label={TEXT_T219} maxLength={102} name="fullName" />
        )}
      </FormSearchLeft>

      {!REGEX_IS_DESKTOP && (
        <FormSearchLeft>
          <ItemInput label={TEXT_T194} maxLength={200} name="projectName" />
        </FormSearchLeft>
      )}

      <FormSearchRight>
        <StyledGroupItem>
          <ItemSelect
            label={TEXT_T193}
            name="countryToTravel"
            onChange={onChangeArrivalCountryCode}
            selectItem={countries}
          />
          <ItemCheckbox label={TEXT_T220} name="isTransit" />
        </StyledGroupItem>
      </FormSearchRight>

      {REGEX_IS_DESKTOP && (
        <FormSearchLeft>
          <ItemInput label={TEXT_T194} maxLength={200} name="projectName" />
        </FormSearchLeft>
      )}

      {!isPathnameSchedules && (
        <Fragment>
          <StyledFormSearchRightGroup>
            <ItemInput
              addonBefore={
                <ItemSelect
                  name="arrivalCityCode"
                  onChange={onChangeArrivalCity}
                  selectItem={[
                    ...(arrivalCities || []),
                    OTHER_CITY_SELECT_ITEMS,
                  ]}
                />
              }
              isDisabled={isDisabledArrivalCity}
              label={TEXT_T217}
              maxLength={200}
              name="arrivalCity"
            />
          </StyledFormSearchRightGroup>
          <FormSearchLeft>
            <ItemSelect
              label={TEXT_T009}
              name="bumonCd"
              selectItem={departments}
            />
          </FormSearchLeft>
        </Fragment>
      )}
      <FormSearchRight>
        <ItemDatePickerRange
          label={TEXT_T195}
          labelFrom={TEXT_T196}
          labelTo={TEXT_T197}
          name="travelDate"
          nameFrom="departureDateTimeDate"
          nameTo="arrivalDateTimeDate"
          onBlurFrom={(event) =>
            onBlurBasic(event, TEXT_T196, "departureDateTimeDate")
          }
          onBlurTo={(event) =>
            onBlurBasic(event, TEXT_T197, "arrivalDateTimeDate")
          }
          onKeyDownFrom={(event) =>
            onKeyDownBasic(event, TEXT_T196, "departureDateTimeDate")
          }
          onKeyDownTo={(event) =>
            onKeyDownBasic(event, TEXT_T197, "arrivalDateTimeDate")
          }
        />
      </FormSearchRight>

      {isSearchAdvance && <StyledTitle type="danger" titleRight={TEXT_T619} />}
    </FormSearch>
  )
}
